module.exports = __webpack_public_path__ + "img/bed-bunk.0936ddbf.svg";